import { Stack, Typography, styled, type CSSObject } from '@mui/material';

import { Section, Link } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledZKPDDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledZKPDSection = styled(Section)(({ theme }) => ({
  height: '100%',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const StyledSectionTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  fontSize: '32px',
  fontWeight: 650,
  paddingBottom: theme.spacing(3),
  display: 'flex',
  textAlign: 'center',
  justifyContent: 'center',
}));

export const StyledSectionTitleSmall = styled(StyledSectionTitle)(
  ({ theme }) => ({
    fontSize: '16px',
    fontWeight: 600,
    paddingBottom: theme.spacing(1),
  })
);

export const StyledTypography = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  maxWidth: '1300px',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  display: 'flex',
  fontSize: '32px',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}));

export const StyledTypographySmall = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: '100%',
  maxWidth: '1300px',
  letterSpacing: '-0.02em',
  paddingBottom: theme.spacing(5),
  fontSize: '16px',
  display: 'block',
}));

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

// Same as in MacBookWindow.styles.tsx?
export const StyledCaseStudyArea = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
}));

export const StyledButtonWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(10),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(5),
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  margin: theme.spacing(2, 0, 1, 1),
}));
